module.exports = __webpack_public_path__ + "static/media/male.a49569be.png";